import ApiService from "./api.service";
export default class BookingService extends ApiService {
    static base_url = `${super.base_url}/bookings`;

    static async cancel(bookingId, axiosInstance, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/${bookingId}/cancel`, null, config);
        return response.data;
    }

    static async payDifference(data, axiosInstance) {
        const payload = {
            new_total: data.new_total,
            checkAvailibility: data.checkAvailibility || false,
            duration: data.duration || null,
            booking_id: data.booking_id,
            old_total: data.old_total,
            success_update: data.success_update || [],
            return_url: data.return_url || (typeof window !== "undefined" ? window.location.origin : undefined),
        };

        const response = await axiosInstance.post(
            `${this.base_url}/${data.booking_id}/pay-difference`,
            payload
        );

        return response.data;
    }

    static async editQuote(bookingId, data, axiosInstance) {
        const response = await axiosInstance.post(
            `${this.base_url}/${bookingId}/edit-quote`,
            data
        );
        return response.data;
    }

    static async refundDifference(data, bookingId, axiosInstance) {
        const response = await axiosInstance.post(
            `${this.base_url}/${bookingId}/refund-difference`,
            {
                old_total: data.old_total,
                new_total: data.new_total,
            }
        );
        return response.data;
    }
}
